import * as Sentry from "@sentry/nextjs";

/**
 * Do not call this function globally, it depends on the window object being available.
 * It must be called after the window object has loaded.
 * Improper usage can cause "ReferenceError: window is not defined" error.
 */

export function storage(): Storage {
  const isLocalStorageAvailable = lsTest();

  if (isLocalStorageAvailable) {
    return localStorage;
  }
  return falseStorage;
}

function lsTest(): boolean {
  const test = "test";

  if (typeof window === "undefined" || !localStorage) {
    return false;
  }

  try {
    localStorage.setItem(test, test);
    localStorage.removeItem(test);
    return true;
  } catch (err) {
    const e = err as Error;
    Sentry.addBreadcrumb({
      category: "localStorage",
      message: "LocalStorage is not available.",
      data: e,
    });

    return false;
  }
}

function noop() {
  return null;
}

const falseStorage = {
  clear: noop,
  getItem: noop,
  setItem: noop,
  removeItem: noop,
  key: noop,
  length: -1,
};
